


































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Inject } from '@cds/common';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';
import { ElForm } from 'element-ui/types/form';
import VueUeditorWrap from "vue-ueditor-wrap";

@Component({
  components: {
    VueUeditorWrap,
  }
})
export default class KpiRemarksPopup extends Vue {
  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  @Emit('saved') // 父级接收事件名
  private async emitSaved(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  @Emit('cancel') // 父级接收事件名
  private async emitClose(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  @Prop() private remarkId!: Number;

  @Watch('remarkId', { immediate: true, deep: true })
  public onChangeRemarkId(newVal: any, oldVal: any) {
    console.log('remarkId watch', newVal)
    const isEdit = typeof newVal === 'number';
    this.isEdit = isEdit;
    if (isEdit) {
      this.fetchRemarkDetail();
    } else {
      this.form = {
        id: undefined,
        postLevel: 'MR', // 默认面向MR
        remarks: '', // 备注内容
      };
    }
  }

  public isEdit: boolean = false;
  public form: any = {
    postLevel: 'MR', // 默认面向MR
    remarks: '', // 备注内容
  };

  // 表单验证规则
  public rules: any = {
    postLevel: [{ required: true, message: '请选择Post Level', trigger: 'change' }],
    remarks: [{ required: true, message: '请输入备注内容', trigger: 'blur' }],
  };

  // UEditor配置
  public myConfig = {
    // 编辑器不自动被内容撑高
    autoHeightEnabled: false,
    // 初始容器高度
    initialFrameHeight: 500,
    // 初始容器宽度
    initialFrameWidth: '100%',
    // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
    serverUrl: '/api/application/ueditor/config',
    // serverUrl: '/api/application/img/upload/imgUpload',
    // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
    UEDITOR_HOME_URL: '/ueditor/',
    toolbars: [[
      'fullscreen', 'source', '|', 'undo', 'redo', 'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript',
      'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', 'forecolor',
      'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc',
      'fontfamily', 'fontsize', 'simpleupload', 'insertimage', 'emotion', /*'scrawl',*/
      /*'music',*/ 'insertvideo', 'insertaudio', 'attachment', 'map',
      'rowspacingtop', 'rowspacingbottom', 'lineheight', 'link', 'unlink'
    ]],
    'fontfamily': [
      { label: '', name: 'songti', val: '宋体,SimSun' },
      { label: '仿宋', name: 'fangsong', val: '仿宋,FangSong' },
      { label: '仿宋_GB2312', name: 'fangsong', val: '仿宋_GB2312,FangSong' },
      { label: '', name: 'kaiti', val: '楷体,楷体_GB2312, SimKai' },
      { label: '', name: 'yahei', val: '微软雅黑,Microsoft YaHei' },
      { label: '', name: 'heiti', val: '黑体, SimHei' },
      { label: '', name: 'lishu', val: '隶书, SimLi' },
      { label: '', name: 'andaleMono', val: 'andale mono' },
      { label: '', name: 'arial', val: 'arial, helvetica,sans-serif' },
      { label: '', name: 'arialBlack', val: 'arial black,avant garde' },
      { label: '', name: 'comicSansMs', val: 'comic sans ms' },
      { label: '', name: 'impact', val: 'impact,chicago' },
      { label: '', name: 'timesNewRoman', val: 'times new roman' }
    ],
    elementPathEnabled: false, // 是否启用元素路径 默认值：true
    wordCount: false, //是否开启字数统计 默认值：true
    // maximumWords: 300, //允许的最大字符数 默认值：10000
    // wordCountMsg: '当前已输入{#count}个字符, 您还可以输入{#leave}个字符。', // 字数统计提示，默认值：'当前已输入{#count}个字符, 您还可以输入{#leave}个字符。 '   {#count}代表当前字数，{#leave}代表还可以输入多少字符数
  };

  public async created(): Promise<void> {
  }

  // 获取备注详情
  private async fetchRemarkDetail(): Promise<void> {
    try {
      const res = await this.nuoxiaoerService.fetchKpiRemarkDetail({ id: this.remarkId });
      if (res) {
        this.form = {
          id: res.id,
          postLevel: res.postLevel || 'MR',
          remarks: res.remarks || ''
        };
      }
    } catch (error) {
      console.error('获取备注详情失败：', error);
      this.$message.error('获取备注详情失败，请刷新重试');
    }
  }

  // 保存表单
  public submitForm(formName: string): void {
    const addRef = (this.$refs.form as ElForm);

    addRef.validate(async (isValid: boolean, invalidFields: object) => {
      if (!isValid) {
        console.log('表单验证失败', invalidFields);
        return false;
      }
      try {
        // 确认保存
        await this.$confirm('是否确认信息发布？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        });

        // 准备提交数据
        let submitData: any = {
          id: this.form.id,
          postLevel: this.form.postLevel,
          remarks: this.form.remarks
        };

        // 判断是新增还是编辑模式
        if (this.isEdit) {
          // 使用更新接口
          await this.nuoxiaoerService.updateKpiRemark(submitData);
          this.$message({ message: '更新成功', type: 'success' });
        } else {
          // 新增模式
          await this.nuoxiaoerService.saveKpiRemark(submitData);
          this.$message({ message: '保存成功', type: 'success' });
        }
        this.emitSaved();
      } catch (error) {
        if (error === 'cancel') {
          // 用户取消操作，不做处理
          return;
        }
        console.error('保存失败：', error);
        this.$message.error('保存失败：' + (error.message || '未知错误'));
      }
    });
  }

  // 取消按钮
  public async handleCancel(): Promise<void> {
    try {
      await this.$confirm('是否关闭当前界面？关闭后，当前界面内容将会丢失', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });
      this.emitClose();
    } catch (error) {
      // 用户取消操作，不做处理
    }
  }
}
